$(document).ready(function () {
  // ──────────────────────────────────────────────────────────────────────────

  window.openCartDrawer = function (showSkeleton) {
    $(".cd_outer").css("display", "flex");
    $("body, html").addClass("overflow-hidden");
    if (showSkeleton) {
      $(".cd_skeleton").addClass("cd_skeleton--visible");
    }
    setTimeout(function () {
      $(".cd_outer").addClass("active");
    }, 100);
  };

  window.closeCartDrawer = function () {
    $(".cd_outer").removeClass("active");
    $("body, html").removeClass("overflow-hidden");
    setTimeout(function () {
      $(".cd_outer").hide();
    }, 500);
  };

  var giftId = 54326178447708;

  function refreshOrRemoveGift() {
    $.getJSON("/cart.js", function (cart) {
      var giftQty = 0;
      var nonGiftQty = 0;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id == giftId) {
          giftQty += cart.items[i].quantity;
        } else {
          nonGiftQty += cart.items[i].quantity;
        }
      }
      if (nonGiftQty == 0 && giftQty > 0) {
        $.post("/cart/change.js", { id: giftId, quantity: 0 }, function () {
          refreshCartDrawer(false);
        });
      } else {
        refreshCartDrawer(false);
      }
    });
  }

  function updateCartBubble(itemCount) {
    var $icon = $("#cart-icon-bubble");
    var $bubble = $icon.find(".cart-count-bubble");

    if (itemCount > 0) {
      if (!$bubble.length) {
        $bubble = $(
          '<div class="cart-count-bubble">' +
            '<span aria-hidden="true"></span>' +
            '<span class="visually-hidden"></span>' +
            "</div>",
        ).appendTo($icon);
      }
      $bubble.find("span[aria-hidden]").text(itemCount < 100 ? itemCount : "");
    } else {
      $bubble.remove();
    }
  }

  window.refreshCartDrawer = function () {
    $(".cd_checkoutbnt").addClass("rendering");

    $.getJSON(
      "/?sections=vivo_cart-drawer&t=" + Date.now(),
      function (sections) {
        var cartHtml = sections["vivo_cart-drawer"];
        if (cartHtml) {
          var $new = $("<div>").html(cartHtml);
          var $content = $new.find(".cart_content--js");
          if ($content.length) $(".cart_content--js").html($content.html());
        }
        $(".cd_checkoutbnt").removeClass("rendering");
      },
    );

    $.getJSON("/cart.js", function (cart) {
      updateCartBubble(cart.item_count);
    });
  };

  // ──────────────────────────────────────────────────────────────────────────

  $(document).on("click", ".header__icon--cart", function (evt) {
    evt.preventDefault();
    openCartDrawer();
  });

  $(document).on("click", ".gp_cta", function (evt) {
    evt.preventDefault();
    var currentId = $(this).attr("data-id");
    var currentQty = parseFloat(
      $(this).closest(".gp_component").find(".gp_quantity-value").html(),
    );
    $.post("/cart/clear.js", function () {
      $.post(
        "/cart/add.js",
        { id: currentId, quantity: currentQty },
        function () {
          openCartDrawer(true);
          refreshCartDrawer(false);
        },
      );
    });
  });

  $(document).on("submit", ".hm_offer-form", function (evt) {
    evt.preventDefault();
    var currentId = $(this).find('input[name="id"]').attr("value");
    var currentQty = $(this).find(".hm_offer-quantity").attr("value");
    $.post("/cart/clear.js", function () {
      $.post(
        "/cart/add.js",
        { id: currentId, quantity: currentQty },
        function () {
          openCartDrawer(true);
          refreshCartDrawer(false);
        },
      );
    });
  });

  $(".custom_pp-btn_gp").click(function (e) {
    e.preventDefault();
    var currentId = $(this).attr("data-id");
    var currentQty = $(this).attr("data-qty");
    $.post("/cart/clear.js", function () {
      $.post(
        "/cart/add.js",
        { id: currentId, quantity: currentQty },
        function () {
          openCartDrawer(true);
          refreshCartDrawer(false);
        },
      );
    });
  });

  $(".pdp_offer-card--btn_real").click(function (e) {
    e.preventDefault();
    var currentId = $(this)
      .closest(".hm_offer-form")
      .find('input[name="id"]')
      .attr("value");
    $.post("/cart/clear.js", function () {
      $.post("/cart/add.js", { id: currentId, quantity: 1 }, function () {
        openCartDrawer(true);
        refreshCartDrawer(false);
      });
    });
  });

  $(".te_product-atc-btn").click(function (e) {
    e.preventDefault();
    var currentId = $(this).attr("data-id");
    var sellingPlan = $(this).attr("data-selling-plan");

    var items = [{ id: currentId, quantity: 1, selling_plan: sellingPlan }];

    $(".te_product-gift").each(function () {
      var giftId = $(this).data("id");
      if (giftId) items.push({ id: giftId, quantity: 1 });
    });

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({ items: items }),
      contentType: "application/json",
      success: function () {
        openCartDrawer(true);
        refreshCartDrawer(false);
      },
    });
  });

  $(".te_product-atc-btn_variants").click(function (e) {
    e.preventDefault();
    var $active = $(".te_product-variant-box.active");
    var variantId = $active.data("id");
    var sellingPlan = $active.data("selling-plan");

    $.post(
      "/cart/add.js",
      { id: variantId, quantity: 1, selling_plan: sellingPlan },
      function () {
        openCartDrawer(true);
        refreshCartDrawer(false);
      },
    );
  });

  $(".te_product-atc-btn_variants_otp").click(function (e) {
    e.preventDefault();
    var $active = $(".te_product-variant-box.active");
    var variantId = $active.data("id");
    var sellingPlan = $active.data("selling-plan");

    if ($(".he_product-sub-btn").hasClass("active")) {
      $.post(
        "/cart/add.js",
        { id: variantId, quantity: 1, selling_plan: sellingPlan },
        function () {
          openCartDrawer(true);
          refreshCartDrawer(false);
        },
      );
    } else {
      $.post("/cart/add.js", { id: variantId, quantity: 1 }, function () {
        openCartDrawer(true);
        refreshCartDrawer(false);
      });
    }
  });

  $(document).on("click", ".cell_cart_upsell_btn", function (evt) {
    evt.preventDefault();
    var $btn = $(this);
    $btn.find(".upsell_btn_content").hide();
    $btn.find(".upsell_btn_loader").css("display", "block");

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: $btn.attr("data-id"),
        quantity: 1,
        properties: { OFFER: "15%" },
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("Failed");
        return r.json();
      })
      .then(function () {
        window.refreshCartDrawer(false);
        $btn.find(".upsell_btn_content").show();
        $btn.find(".upsell_btn_loader").hide();
      })
      .catch(function (error) {
        console.error("Upsell error:", error);
        alert("Something went wrong. Please try again.");
        $btn.find(".upsell_btn_content").show();
        $btn.find(".upsell_btn_loader").hide();
      });
  });

  $(".col_pp_Atc_main__js").click(function () {
    var $btn = $(this).addClass("loading");
    var currentMode = $(".col_product-mode.active").attr("data");
    var data;
    if (currentMode == "sub") {
      data = {
        id: $(".col_product_variant.active").attr("data-sub-id"),
        quantity: 1,
        selling_plan: $(".col_product_variant.active").attr(
          "data-selling-plan",
        ),
      };
    } else {
      data = {
        id: $(".col_product_variant.active").attr("data-id"),
        quantity: 1,
      };
    }
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        openCartDrawer(true);
        refreshCartDrawer(false);
        $btn.removeClass("loading");
      },
      error: function () {
        alert("Error adding item to the cart.");
        $btn.removeClass("loading");
      },
    });
  });

  $(".cd_outer").click(function (e) {
    if (!$(e.target).closest(".cd_inner").length) {
      closeCartDrawer();
    }
  });

  $(document).on("click", ".cd_close", function () {
    closeCartDrawer();
  });

  $(document).on("click", ".cd_switch-save_btn", function () {
    var $btn = $(this).addClass("loading").attr("disabled", true);
    var addData = {
      id: $btn.attr("data-id"),
      quantity: $btn.attr("data-qty"),
      selling_plan: $btn.attr("data-selling-plan"),
    };
    $.post("/cart/clear.js", function () {
      $.post("/cart/add.js", addData, function () {
        refreshCartDrawer(false);
      });
    });
  });

  $(document).on("click", ".cd_item-plus", function () {
    var $item = $(this).closest(".cd_item").addClass("loading");
    var currentVal = parseFloat($item.find(".cd_item-val").html()) + 1;
    $.post(
      "/cart/change.js",
      { id: $item.attr("data-id"), quantity: currentVal },
      function () {
        refreshCartDrawer(false);
      },
    );
  });

  $(document).on("click", ".cd_item-remove", function () {
    var $item = $(this).closest(".cd_item").addClass("loading");
    $.post(
      "/cart/change.js",
      { id: $item.attr("data-id"), quantity: 0 },
      refreshOrRemoveGift,
    );
  });

  $(document).on("click", ".cd_item-minus", function () {
    var $item = $(this).closest(".cd_item").addClass("loading");
    var currentVal = parseFloat($item.find(".cd_item-val").html()) - 1;
    $.post(
      "/cart/change.js",
      { id: $item.attr("data-id"), quantity: currentVal },
      refreshOrRemoveGift,
    );
  });

  $(document).on("click", ".cd_checkoutbnt__out", function (evt) {
    $(this).find(".cd_checkoutbnt").addClass("loading");

    evt.preventDefault();

    function proceedToCheckout() {
      window.location.href = "/checkout";
      setTimeout(function () {
        $(".cd_checkoutbnt").removeClass("loading");
      }, 1000);
    }

    proceedToCheckout();
  });

  $("#TSProductSubmitQuantityCart").click(function (evt) {
    evt.preventDefault();

    var currentId = $(".simple-product_shade.active").attr("data-id");
    var currentQty = parseFloat(
      $(".product_main-atc-qty-box").find(".psa_qty_value").html(),
    );
    var data = { items: [{ id: currentId, quantity: currentQty }] };
    if ($('.main_product-sub-selector-line[data="sub"]').hasClass("active")) {
      data.items[0].selling_plan = $(
        '.main_product-sub-selector-line[data="sub"]',
      ).attr("data-id");
    }

    $.post("/cart/add.js", data, function () {
      $.post(
        "/cart/update.js",
        { attributes: { discount_code: "testing12345609887" } },
        function () {
          window.refreshCartDrawer(false);
          window.openCartDrawer(true);
        },
      );
    });
  });
});
